import React, { useState, useEffect, useRef } from "react";
import Calendar from "../components/CalenderHeatmap";
import { Link, useLocation } from "react-router-dom";

import { SpinStretch } from "react-cssfx-loading";
import Navbar from "../components/Navbar";
import LineChart from "../components/LineChart";
import Leaderboard from "../components/Leaderboard.jsx";
import { db } from "../components/firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { collection, query } from "firebase/firestore";
import NumberTicker from "../components/ui/number-ticker";
import BlurIn from "../components/ui/blur-text";
import { toast } from "../components/ui/use-toast";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import BoltOutlinedIcon from "@mui/icons-material/BoltOutlined";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import ChevronRightOutlinedIcon from "@mui/icons-material/ChevronRightOutlined";
import "./stats.css";
import Seo from "../components/Seo";

const data = [
  { date: "2022-03-26", count: 3 },
  { date: "2022-03-02", count: 1 },
  { date: "2022-03-03", count: 3 },
  { date: "2022-03-04", count: 1 },
  { date: "2022-03-05", count: 4 },
  // add more data for the month
];

const HEATMAP_COLORS = ["#221d1d", "#d6e87a", "#8cc665", "#44a340", "#1e6823"];

async function statsExtract(data) {
  let max_dur = 0,
    max_streak = 0,
    cur_streak = 0;
  if (data.length == 0) {
    return { max_dur, max_streak, cur_streak };
  }
  const oneDayInMillis = 24 * 60 * 60 * 1000;
  let dateObject;
  //to extract max duration in a day, max streak , cur streak
  for (var i = 0; i < data.length; i++) {
    const parts = data[i]["date"].split("-");
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1] - 1, 10); // Months are zero-based in JavaScript
    const day = parseInt(parts[2], 10);

    dateObject = new Date(year, month, day);

    if (max_dur < parseInt(data[i]["dayminutes"])) {
      max_dur = parseInt(data[i]["dayminutes"]);
    }

    if (i != 0) {
      const parts = data[i - 1]["date"].split("-");
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1] - 1, 10); // Months are zero-based in JavaScript
      const day = parseInt(parts[2], 10);
      const prev = new Date(year, month, day);
      const cd = dateObject;
      const time_dif = cd - prev;
      if (time_dif == oneDayInMillis) {
        cur_streak++;
      } else {
        cur_streak = 0;
      }
    }
    if (cur_streak + 1 > max_streak) {
      max_streak = cur_streak + 1;
    }
  }
  const cur_date = new Date().toDateString();
  const yesterday = new Date(
    new Date().getTime() - oneDayInMillis
  ).toDateString();
  const tomorrow = new Date(
    new Date().getTime() + oneDayInMillis
  ).toDateString();
  cur_streak++;
  const lastfocusday = dateObject.toDateString();

  if (
    lastfocusday != cur_date &&
    lastfocusday != tomorrow &&
    lastfocusday != yesterday
  ) {
    cur_streak = 0;
  }
  return { max_dur, max_streak, cur_streak };
}

const Stats = (props) => {
  const location = useLocation();
  const propsData = location.state;
  const ownEmail = localStorage.getItem("userEmail") || "example@gmail.com";

  const [userEmail, setuserEmail] = useState(
    (propsData && propsData.email) || ownEmail
  );
  // Keep the viewed user in sync with navigation state (handles both
  // opening someone's profile and going back to your own stats)
  if (propsData && propsData.email !== userEmail) {
    setuserEmail(propsData.email);
  }
  if (!propsData && userEmail !== ownEmail) {
    setuserEmail(ownEmail);
  }
  const viewingOther = userEmail !== ownEmail;
  const isLoggedIn = !!localStorage.getItem("userEmail");

  const usersRef = collection(db, "newusers");
  const allusersQuery = query(usersRef);
  const [allusers] = useCollectionData(allusersQuery, { idField: "id" });

  const [calendardata, setcalendardata] = useState(data);
  const [friendEmails, setFriendEmails] = useState([]);
  const [totalfocusminutes, settotalfocusminutes] = useState(-1);
  const [userName, setuserName] = useState(
    () => localStorage.getItem("userName") || ""
  );
  const [showScrollBtn, setShowScrollBtn] = useState(false);
  const [maxStreak, setMaxStreak] = useState(0);
  const [maxDuration, setMaxDuration] = useState(0);
  const [currentStreak, setCurrentStreak] = useState(0);
  const [photodp, setphotodp] = useState("");
  // none | friend | sent
  const [friendStatus, setFriendStatus] = useState("none");
  const heatmapScrollRef = useRef(null);
  const currentYear = new Date().getFullYear();
  const [heatmapYear, setHeatmapYear] = useState(currentYear);

  const fetchUserData = async () => {
    settotalfocusminutes(-1);
    const oldDate = new Date();
    var curdate = oldDate.toDateString();

    let response = await fetch(
      // "http://localhost:5000/api/getstats",
      "https://animedoro-backend.vercel.app/api/getstats",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: userEmail,
          curDate: curdate,
        }),
      }
    );
    const json = await response.json();
    if (response.status === 200) {
      settotalfocusminutes(json.totalFocusMinutes);
      setcalendardata(json.heatmapdays);
      if (!viewingOther) {
        setFriendEmails(json.userFriends || []);
      }
      let { max_dur, max_streak, cur_streak } = await statsExtract(
        json.heatmapdays
      );
      setMaxDuration(max_dur);
      setMaxStreak(max_streak);
      setCurrentStreak(cur_streak);
      // For own profile, load avatar from localStorage (set by Navbar)
      if (!viewingOther) {
        const saved = localStorage.getItem("userAvatarUrl");
        setphotodp(saved || "");
      }
    }
  };
  useEffect(() => {
    setphotodp("");
    setHeatmapYear(currentYear);
    fetchUserData();
  }, [userEmail]);

  // When viewing someone else, check whether they are already a friend
  useEffect(() => {
    setFriendStatus("none");
    if (!isLoggedIn || !viewingOther) return;
    let cancelled = false;
    (async () => {
      try {
        const response = await fetch(
          "https://animedoro-backend.vercel.app/api/getstats",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              email: localStorage.getItem("userEmail"),
              curDate: new Date().toDateString(),
            }),
          }
        );
        const json = await response.json();
        if (!cancelled && response.status === 200 && json.userFriends) {
          setFriendEmails(json.userFriends);
          if (json.userFriends.includes(userEmail)) {
            setFriendStatus("friend");
          }
        }
      } catch (e) {
        // ignore - the add friend button stays available
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userEmail]);

  async function sendFriendRequest() {
    if (!isLoggedIn) return;
    setFriendStatus("sent");
    try {
      const response = await fetch(
        "https://animedoro-backend.vercel.app/api/friendrequest",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            useremail: localStorage.getItem("userEmail"),
            friendmail: userEmail,
          }),
        }
      );
      const json = await response.json();
      if (json.msg) {
        toast({ title: "Friend request", description: json.msg });
      } else {
        toast({
          title: "Friend request sent!",
          description: `${
            userName
              ? userName.charAt(0).toUpperCase() + userName.slice(1)
              : "They"
          } can accept it from their notifications.`,
        });
      }
    } catch (e) {
      setFriendStatus("none");
      toast({
        title: "Something went wrong",
        description: "Couldn't send the friend request. Please try again.",
        variant: "destructive",
      });
    }
  }

  // Keep name in sync with Firestore in real-time (picks up edits immediately)
  useEffect(() => {
    if (!allusers || !allusers[0]) return;
    if (!viewingOther) {
      const uid = localStorage.getItem("uid");
      if (!uid) return;
      const usr = allusers[0][uid];
      if (usr && usr.name) setuserName(usr.name);
    } else {
      const usr = Object.values(allusers[0]).find(
        (u) => u.email === userEmail
      );
      if (usr && usr.name) setuserName(usr.name);
      if (usr && usr.img) setphotodp(usr.img);
    }
  }, [allusers, userEmail]);

  // Friends of the logged-in user (email + display name) for chart compare
  const compareFriends = React.useMemo(() => {
    const profiles =
      allusers && allusers[0] ? Object.values(allusers[0]) : [];
    return friendEmails.map((email) => {
      const usr = profiles.find((u) => u && u.email === email);
      return { email, name: (usr && usr.name) || email.split("@")[0] };
    });
  }, [friendEmails, allusers]);

  // Firestore profile of the user being viewed (presence info)
  const viewedUser =
    viewingOther && allusers && allusers[0]
      ? Object.values(allusers[0]).find((u) => u.email === userEmail)
      : null;

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setShowScrollBtn(scrollTop > 4000);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll the yearly heatmap to roughly the current month (only relevant
  // when the heatmap actually overflows, e.g. on small screens)
  useEffect(() => {
    if (totalfocusminutes === -1) return;
    const el = heatmapScrollRef.current;
    if (!el) return;
    if (heatmapYear !== currentYear) {
      el.scrollLeft = 0;
      return;
    }
    const yearStart = new Date(currentYear, 0, 1);
    const yearRatio = (Date.now() - yearStart.getTime()) / (365 * 864e5);
    el.scrollLeft = Math.max(0, yearRatio * el.scrollWidth - el.clientWidth * 0.7);
  }, [totalfocusminutes, heatmapYear]);

  const handleGoToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const focusDays = calendardata ? calendardata.length : 0;
  const minYear =
    calendardata && calendardata.length > 0 && calendardata[0].date
      ? parseInt(calendardata[0].date.split("-")[0], 10)
      : currentYear;
  const dailyAverage =
    focusDays > 0 && totalfocusminutes > 0
      ? Math.round(totalfocusminutes / focusDays)
      : 0;
  const displayName = userName
    ? userName.charAt(0).toUpperCase() + userName.slice(1)
    : "";

  return (
    <div
      className="statsscroll font-mod stats-page"
      style={{ backgroundColor: "black", minHeight: "100vh" }}
    >
      <Seo
        path="/stats"
        title="Your Study Stats, Streaks & Leaderboard"
        description="Track your focus time, study streaks and progress over time with Otakufy stats, and see how you rank on the leaderboard against fellow otakus."
      />
      <Navbar />

      <button
        id="ScrollTopBtn"
        style={{ display: showScrollBtn ? "" : "none" }}
        onClick={handleGoToTop}
      >
        ↑
      </button>

      {totalfocusminutes === -1 ? (
        <div className="flex justify-center my-5 py-5">
          <SpinStretch color="#F5E8C7" />
        </div>
      ) : (
        <div className="stats-container">
          {viewingOther && (
            <div className="profile-banner">
              {isLoggedIn && (
                <Link to="/stats" className="profile-banner-back">
                  <ArrowBackOutlinedIcon style={{ fontSize: 16 }} />
                  <span>My Stats</span>
                </Link>
              )}
              <span className="profile-banner-text">
                You're viewing{" "}
                <strong>{displayName || "another user"}</strong>'s profile
              </span>
            </div>
          )}

          <div className="stats-profile-card">
            <div className="stats-profile-main">
              {photodp.length !== 0 ? (
                <img
                  className="stats-avatar"
                  src={`${photodp}`}
                  alt="user dp"
                />
              ) : (
                <div className="stats-avatar stats-avatar-fallback">
                  {(displayName || "?").charAt(0)}
                </div>
              )}
              <div className="stats-profile-info">
                {displayName && (
                  <BlurIn
                    className="!text-3xl md:!text-4xl !mb-0 !leading-tight stats-namehead"
                    word={displayName}
                  />
                )}
                <div className="stats-profile-meta">
                  {viewingOther && viewedUser ? (
                    <span
                      className={`presence-chip ${
                        viewedUser.studying ? "studying" : "resting"
                      }`}
                    >
                      <span className="presence-dot"></span>
                      {viewedUser.studying ? "Studying now" : "Resting"}
                    </span>
                  ) : (
                    !viewingOther && (
                      <span className="stats-profile-sub">
                        Your focus stats
                      </span>
                    )
                  )}
                </div>
              </div>
            </div>
            {viewingOther && isLoggedIn && (
              <div className="stats-profile-action">
                {friendStatus === "friend" ? (
                  <span className="friend-chip">
                    <Diversity1OutlinedIcon style={{ fontSize: 16 }} />
                    Friends
                  </span>
                ) : friendStatus === "sent" ? (
                  <span className="friend-chip sent">Request sent ✓</span>
                ) : (
                  <button className="addfriend-btn" onClick={sendFriendRequest}>
                    <PersonAddAlt1OutlinedIcon style={{ fontSize: 17 }} />
                    Add Friend
                  </button>
                )}
              </div>
            )}
          </div>

          <div className="stat-grid">
            <div className="stat-tile tile-focus">
              <div className="stat-tile-head">
                <span className="stat-tile-label">Total Focus</span>
                <span className="stat-tile-icon">
                  <AccessTimeOutlinedIcon style={{ fontSize: 19 }} />
                </span>
              </div>
              <div className="stat-tile-value">
                <NumberTicker value={Math.floor(totalfocusminutes / 60)} />
                <span className="stat-tile-unit">h</span>
                <NumberTicker value={totalfocusminutes % 60} />
                <span className="stat-tile-unit">m</span>
              </div>
              <div className="stat-tile-sub">
                <span>All-time focus</span>
              </div>
            </div>

            <div className="stat-tile tile-streak">
              <div className="stat-tile-head">
                <span className="stat-tile-label">Current Streak</span>
                <span className="stat-tile-icon">
                  <LocalFireDepartmentOutlinedIcon style={{ fontSize: 19 }} />
                </span>
              </div>
              <div className="stat-tile-value">
                <NumberTicker value={currentStreak} />
                <span className="stat-tile-unit">
                  {currentStreak === 1 ? "day" : "days"}
                </span>
              </div>
              <div className="stat-tile-sub">
                <span>Best streak</span>
                <strong>
                  {maxStreak} {maxStreak === 1 ? "day" : "days"}
                </strong>
              </div>
            </div>

            <div className="stat-tile tile-days">
              <div className="stat-tile-head">
                <span className="stat-tile-label">Focus Days</span>
                <span className="stat-tile-icon">
                  <CalendarMonthOutlinedIcon style={{ fontSize: 19 }} />
                </span>
              </div>
              <div className="stat-tile-value">
                <NumberTicker value={focusDays} />
                <span className="stat-tile-unit">days</span>
              </div>
              <div className="stat-tile-sub">
                <span>Daily average</span>
                <strong>{dailyAverage} min</strong>
              </div>
            </div>

            <div className="stat-tile tile-best">
              <div className="stat-tile-head">
                <span className="stat-tile-label">Best Day</span>
                <span className="stat-tile-icon">
                  <BoltOutlinedIcon style={{ fontSize: 19 }} />
                </span>
              </div>
              <div className="stat-tile-value">
                <NumberTicker value={maxDuration} />
                <span className="stat-tile-unit">min</span>
              </div>
              <div className="stat-tile-sub">
                <span>Most focus in a single day</span>
              </div>
            </div>
          </div>

          {calendardata && (
            <LineChart
              key={userEmail}
              data={calendardata}
              ownerName={viewingOther ? displayName || "Them" : "You"}
              friends={compareFriends.filter((f) => f.email !== userEmail)}
              canCompare={isLoggedIn}
            />
          )}

          <div className="heatmap-card">
            <div className="card-head">
              <div>
                <h2 className="section-title">Yearly Activity</h2>
                <p className="section-sub">
                  Every square is a day — the greener, the more focused
                </p>
              </div>
              <div className="heatmap-controls">
                <div className="year-switch">
                  <button
                    aria-label="Previous year"
                    disabled={heatmapYear <= minYear}
                    onClick={() => setHeatmapYear((y) => y - 1)}
                  >
                    <ChevronLeftOutlinedIcon style={{ fontSize: 18 }} />
                  </button>
                  <span>{heatmapYear}</span>
                  <button
                    aria-label="Next year"
                    disabled={heatmapYear >= currentYear}
                    onClick={() => setHeatmapYear((y) => y + 1)}
                  >
                    <ChevronRightOutlinedIcon style={{ fontSize: 18 }} />
                  </button>
                </div>
                <div className="heatmap-legend">
                  Less
                  {HEATMAP_COLORS.map((c) => (
                    <span
                      key={c}
                      className="legend-cell"
                      style={{ backgroundColor: c }}
                    ></span>
                  ))}
                  More
                </div>
              </div>
            </div>
            <div className="heatmap-scroll" ref={heatmapScrollRef}>
              <div className="heatmap-inner">
                <Calendar data={calendardata} year={heatmapYear} />
              </div>
            </div>
          </div>
        </div>
      )}

      <div style={{ padding: "1em" }} id="main">
        <Leaderboard />
      </div>
    </div>
  );
};

export default React.memo(Stats);
